enum Event {
  WelcomeViewed = "Welcome - Viewed",
  WelcomeLoginClicked = "Welcome - Login Clicked",

  HeaderLogout = "Header - Logout Clicked",

  LoginViewed = "Login - Viewed",
  LoginBackClicked = "Login - Back Clicked",
  LoginPrivacyPolicyClicked = "Login - Privacy Policy Clicked",
  LoginTermsofServiceClicked = "Login - Terms of Service Clicked",
  LoginLoginClicked = "Login - Login Clicked",
  LoginErrorViewed = "Login - Error Viewed",

  ConfirmationCodeViewed = "Confirmation Code - Viewed",
  ConfirmationCodeResendClicked = "Confirmation Code - Resend Clicked",
  ConfirmationCodeConfirmClicked = "Confirmation Code - Confirm Clicked",
  ConfirmationCodeErrorViewed = "Confirmation Code - Error Viewed",
  ConfirmationCodeBackClicked = "Confirmation Code - Back Clicked",

  TryagainViewed = "Try again - Viewed",
  TryagainBackClicked = "Try again - Back Clicked",

  ConnectViewed = "Connect - Viewed",
  ConnectActivateClicked = "Connect - Activate Clicked",
  ConnectActivateFailed = "Connect - Activate Subscription Failed",
  ConnectEditClicked = "Connect - Edit Clicked",
  ConnectEditFailed = "Connect - Edit Subscription Failed",
  ConnectReactivateClicked = "Connect - Reactivate Clicked",
  ConnectScrolled = "Connect - Scrolled",
  ConnectCameraClicked = "Connect - Camera Clicked",

  SubscriptionDetailsViewed = "Subscription Details - Viewed",
  SubscriptionDetailsBackClicked = "Subscription Details - Back Clicked",
  SubscriptionDetailsScrolled = "Subscription Details - Scrolled",
  SubscriptionDetailsSubmitClicked = "Subscription Details - Submit Clicked",
  SubscriptionDetailsCancelSubscriptionClicked = "Subscription Details - Cancel Subscription Clicked",

  SuccessModalViewed = "Success Modal - Viewed",
  SuccessModalXClicked = "Success Modal - X Clicked",
  SuccessModalSubmitClicked = "Success Modal - Submit Clicked",

  CancelSubscriptionPromptOneClicked = "Cancel Subscription Prompt - Cancel One Subscription Clicked",
  CancelSubscriptionPromptAllClicked = "Cancel Subscription Prompt - Cancel All Subscriptions Clicked",

  CancelSubscriptionViewed = "Cancel Subscription - Viewed",
  CancelSubscriptionXClicked = "Cancel Subscription - X Clicked",
  CancelSubscriptionContactUsClicked = "Cancel Subscription - Contact Us Clicked",
  CancelSubscriptionReasonClicked = "Cancel Subscription - Reason Clicked",
  CancelSubscriptionDontCancelClicked = "Cancel Subscription - Don`t Cancel Clicked",
  CancelSubscriptionYesClicked = "Cancel Subscription - Yes Clicked",
  CancelSubscriptionFailed = "Cancel Subscription - Cancel Subscription Failed",
}

export default Event;
